import React from 'react';
import background from './../img/intro-bg.jpg';


export default function About () {
    return (
        <>
            <div id="home" className="intro route bg-image" style={{backgroundImage: `url(${background})`}}>
               <div className="overlay-itro"></div>
               <div className="intro-content display-table">
                 <div className="table-cell">
                   <div className="container">
                     <p className="display-6 color-d">Hello, world!</p>
                     <h1 className="intro-title mb-4">I am Ibrahim Nour</h1>
                     <p className="intro-subtitle">Frontend Web Developer</p>
                      <p className="pt-3"><a className="btn btn-primary btn js-scroll px-4" href="#about" role="button">About Me</a></p>
                   </div>
                   <div class="socials">
                   <ul>
                     <li><a href="https://www.linkedin.com/in/ibra-nour/" target="_blank"><span class="ico-circle " ><i class="ion-social-linkedin  text-white" ></i></span></a></li>
                     <li><a href="https://www.facebook.com/ibrahim.nour.1042/" target="_blank"><span class="ico-circle " ><i class="ion-social-facebook  text-white" ></i></span></a></li>
                     <li><a href="https://github.com/Nourcova" target="_blank"><span class="ico-circle " ><i class="ion-social-github text-white"></i></span></a></li>
                   </ul>
                 </div>
                 </div>
               </div>
               </div>
             
               
              
               <div id="about" className="about-mf sect-pt4 route">
                   <div className="container">
                   <div className="row">
                       <div className="col-sm-12">
                       <div className="box-shadow-full">
                           <div className="row">
                           <div className="col-md-6">
                               <div className="row">
                               <div className="col-sm-6 col-md-5">
                                   <div className="about-img">
                                   <img src="img/testimonial.jpg" className="img-fluid rounded b-shadow-a" alt="Nour photo"/>
                                   </div>
                               </div>
                               <div className="col-sm-6 col-md-7">
                                   <div className="about-info">
                                   <p><span className="title-s">Name: </span> <span>Ibrahim Nour</span></p>
                                   <p><span className="title-s">Profile: </span> <span>Frontend developer</span></p>
                                   <p><span className="title-s">Email: </span> <span>ibrahamnour22@gmail.com</span></p>
                                   <p><span className="title-s">Phone: </span> <span>00961 70164292</span></p>
                                   </div>
                               </div>
                               </div>
                               <div className="skill-mf">
                               <p className="title-s">Skills</p>
                               <span>HTML</span> <span className="pull-right">95%</span>
                               <div className="progress">
                                   <div className="progress-bar" role="progressbar" style={{"width": "95%"}} aria-valuenow="85" aria-valuemin="0"
                                   aria-valuemax="100"></div>
                               </div>
                               <span>CSS3</span> <span className="pull-right">95%</span>
                               <div className="progress">
                                   <div className="progress-bar" role="progressbar" style={{"width": "95%"}} aria-valuenow="75" aria-valuemin="0"
                                   aria-valuemax="100"></div>
                               </div>
                               <span>JAVASCRIPT</span> <span className="pull-right">85%</span>
                               <div className="progress">
                                   <div className="progress-bar" role="progressbar" style={{"width": "85%"}} aria-valuenow="50" aria-valuemin="0"
                                   aria-valuemax="100"></div>
                               </div>
                               <span>REACT</span> <span className="pull-right">85%</span>
                               <div className="progress">
                                   <div className="progress-bar" role="progressbar" style={{"width": "85%"}} aria-valuenow="90" aria-valuemin="0"
                                   aria-valuemax="100"></div>
                               </div>
                               </div>
                           </div>
                           <div className="col-md-6">
                               <div className="about-me pt-4 pt-md-0">
                               <div className="title-box-2">
                                   <h5 className="title-left">
                                   About me
                                   </h5>
                               </div>
                               <p className="lead">
                                   Studying Computer Science in the Lebanese University was just the gateway to my entry
                                   into the world of programming. My interest and appreciation for the visual arts
                                   led me to take many graphic and game development-related courses, and here
                                   I realized my passion and fondness for graphic and interactive content.
                               </p>
                               <p className="lead">
                                   After spending a five-month intensive course in Front-end Web Development,
                                   things became much more interesting to me. Designing web pages using my programming and
                                   design skills and adding my technical touches to them is what I like most. 
                               </p>
                               </div>
                           </div>
                           </div>
                       </div>
                       </div>
                   </div>
                   </div>
               </div>
        </>
    );
}